// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1221":"2cc7e8dc","7412":"2cc7e8dc"}[chunkId] + ".chunk.css";
};